const STICKY_HEADER_SELECTOR = ".site-header";

const scrollToSection = element => {
  if (!element) return;

  const stickyHeader = document.querySelector(STICKY_HEADER_SELECTOR);
  const stickyHeaderHeight = stickyHeader ? stickyHeader.offsetHeight : 0;
  const targetTop = element.getBoundingClientRect().top + window.scrollY;

  window.scrollTo({
    top: targetTop - stickyHeaderHeight,
    behavior: "smooth"
  });
};

export default scrollToSection;
